import ProducerDetails from './ProducerDetails';

export default ProducerDetails;
